export default __webpack_public_path__ + "static/media/transporte-colectivo2.43469661.png";